import React, { useState } from "react";
import styles from "./Software.module.css";
import SimpleBtn from "../../../components/Button/SimpleBtn";
import useIsMobile from "../../../utils/isMobile";

function Software({
  name,
  title,
  url,
  apkDownloadLink,
  images,
  desc,
  usages,
  features,
}) {
  const [imgSelected, setImgSelected] = useState();
  const [imgHover, setImgHover] = useState();
  const isMobile = useIsMobile();

  return (
    <>
      <div className={`${styles.software}`}>
        <div className={`${styles.softwareContents}`}>
          <div className={`${styles.header}`}>
            <h2 className={`${styles.title}`}>{title}</h2>
            <SimpleBtn link={url} className={`${styles.goTo}`}>
              رفتن به برنامه
            </SimpleBtn>
            {apkDownloadLink && (
              <SimpleBtn
                link={apkDownloadLink}
                className={`${styles.androidLink}`}>
                دانلود نسخه اندروید
              </SimpleBtn>
            )}
          </div>
          <p className={`${styles.desc}`}>{desc}</p>
          <div className={`${styles.softwareBody}`}>
            <details className={styles.bodyDetails} name="body-details">
              <summary className={styles.detailsTitle}>کاربرد ها</summary>

              {usages?.map((e) => (
                <details name="sub-details">
                  <summary className={styles.detailsSubtitles}>
                    {e.industry}
                  </summary>
                  <p>{e.usage},</p>
                </details>
              ))}
            </details>
            <details className={styles.bodyDetails} name="body-details">
              <summary className={styles.detailsTitle}>ویژگی ها</summary>

              {features?.map((e) => (
                <details name="sub-details">
                  <summary className={styles.detailsSubtitles}>
                    {e.title}
                  </summary>
                  <p>{e.description},</p>
                </details>
              ))}
            </details>
          </div>
        </div>
        <div className={`${styles.album}`}>
          {images.map((imgSrc, index) =>
            imgSrc ? (
              <img
                key={index}
                src={imgSrc}
                alt={`${name} ${index + 1}`}
                className={
                  imgSelected === index
                    ? styles.imgSelected
                    : imgHover === index
                    ? styles.imgHover
                    : ""
                }
                style={
                  !isMobile && imgSelected && imgSelected != index
                    ? { display: "none" }
                    : { display: "block" }
                }
                onClick={(e) => {
                  imgSelected === index
                    ? setImgSelected(null)
                    : setImgSelected(index);
                }}
                onMouseEnter={(e) => setImgHover(index)}
                onMouseLeave={(e) => setImgHover(null)}
              />
            ) : null
          )}
        </div>
      </div>
    </>
  );
}

export default Software;
